/**
 * Model for favorite event user data
 */
export class FavoriteEvent {
  /**
   * Unique identifier of the user data record that stores this favorite event.
   */
  userDataId: number;

  /**
   * Event ID
   */
  eventId: number;

  /**
   * Parses favorite event data from the web service
   * @param data Favorite event data as returned by the API
   * @returns {FavoriteAirport} Parsed favorite event data
   */
  static parse(data: any): FavoriteEvent {
    return Object.assign(new FavoriteEvent(), {
      userDataId: data.userDataId,
      eventId: data.eventId
    });
  }
}
